import styled from '@emotion/styled';
import AppleAppStore from '../../assets/images/AppleAppStore.svg';
import GooglePlayStore from '../../assets/images/GooglePlayStore.svg';

const NewDashboardMobileAppDownload = () => {
  return (
    <MobileStoreLinksContainer>
      <MobileStoreLink
        data-testid="apple-app-store-link"
        target="_blank"
        rel="noreferrer noopener"
        href="https://apps.apple.com/us/app/one-sunrun-sales-app/id6749865739"
        aria-label="Apple App store">
        <img src={AppleAppStore} alt={'Apple App Store logo'} />
      </MobileStoreLink>
      <MobileStoreLink
        data-testid="google-play-store-link"
        target="_blank"
        rel="noreferrer noopener"
        href="https://play.google.com/store/apps/details?id=com.sunrun.sunrunone"
        aria-label="Google Play store">
        <img src={GooglePlayStore} alt={'Google Play store logo'} />
      </MobileStoreLink>
    </MobileStoreLinksContainer>
  );
};

const MobileStoreLinksContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 0 16px 16px 16px;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const MobileStoreLink = styled.a`
  max-width: 48%;
  width: 180px;
  img {
    width: 100%;
  }
`;

export { NewDashboardMobileAppDownload };
